import React from "react";
import { connect } from "react-redux";
import CreatableSelect from "react-select/creatable";
import { Field, reduxForm, reset, getFormValues, change } from "redux-form";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  openEventGuideModal,
  filesChanged,
  insertEventguide,
  fetchEventGuideList,
  loadEditeventguidesData,
  updateEventGuideFiles,
  getDispalyCategoryOrder,
} from "ActionsEventguide";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  COMMON_FAIL_MESSAGE,
  maxLengthObjectFc,
  validateUrl,
  BASE_IMAGES_URL,
} from "Constants";
import LocaleStrings from "Languages";
import EventGuideFileUpload from "EventGuideFileUpload";
import IconCropper from "IconCropper";
import IconPicker from "IconPicker";
import BetaFeature from "BetaFeature";

var MAXLENOBJ = {};

class EditEventGuide extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      btnloading: false,
      loading: false,
      linkFieldName: "",
      linkFieldLable: "",
      callFor: "",
      isrichtext: false,
      whatToshow: "Content",
      isText: true,
      input: "",
      flag: true,
      category: "",
      categoryValue: { label: "", value: "" },
      categoryValueLength: "0",
      iconPreviewUrl: "",
      icon: "",
      iconScreen: "",
    };
    this.close = this.close.bind(this);
    this.onIconChange = this.onIconChange.bind(this);
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
    var { initialValues, toEdit } = this.props;
    if (toEdit && initialValues.image) {
      let itsImage =
        initialValues.image.endsWith(".jpg") ||
        initialValues.image.endsWith(".png");
      if (itsImage) {
        this.setState({ iconScreen: "iconFromImage" });
      } else {
        this.setState({ iconScreen: "iconFromLibrary" });
      }
    }
  }

  // Modal Clse [add/edit]
  close() {
    let files = [
      { position: "file1", file: "", filename: "" },
      { position: "file2", file: "", filename: "" },
      { position: "file3", file: "", filename: "" },
      { position: "file4", file: "", filename: "" },
      { position: "file5", file: "", filename: "" },
      { position: "file6", file: "", filename: "" },
      { position: "file7", file: "", filename: "" },
      { position: "file8", file: "", filename: "" },
      { position: "file9", file: "", filename: "" },
      { position: "file10", file: "", filename: "" },
    ];
    this.props.openEventGuideModal({ showModal: false });
    this.setState({ showModal: false });
    this.props.reset();
    this.props.updateEventGuideFiles(files);
    this.props.filesChanged({ ischanged: false });

    this.setState({ whatToshow: "Content" });
    //loadEditeventguidesData
    this.props.loadEditeventguidesData({});
    this.setState({ loading: true });
    // Call For Event Guide List On Modal Close (For Table refresh)
    this.props.fetchEventGuideList(this.props.session, (CallBackResponse) => {
      this.setState({ loading: false });
    });
  }

  // On Form Submit Challenges
  onFormSubmit(values, dispatch, props) {
    // console.log("values :- ", values);

    // Category related section start
    let res = "";
    let cate = values.category;
    // console.log(typeof cate);
    if (typeof cate !== "object" && cate !== "") {
      res = cate;
    } else {
      res = cate.value;
    }
    values.category = res;

    this.setState({ btnloading: true });
    // Call to get dispalycategoryorder
    this.props.getDispalyCategoryOrder(props.session, values, (callbackres) => {
      var {
        filechanged,
        eventguidefilesList,
        maxDisplayorder,
        toEdit,
        initialValues,
      } = props;
      var maxDisplayorderVal = parseInt(maxDisplayorder.data.displayorder);
      if (toEdit) {
        maxDisplayorderVal = initialValues.displayorder;
      }

      values.title = values.title.trim();

      if (
        values.type == "richtext" &&
        !_.isEmpty(values.content) &&
        !_.includes(values.content, `<div style="font-family: DM Sans`)
      ) {
        values.content = `<div style="font-family: DM Sans; font-weight: 400;">${values.content}</div>`;
      }

      var data = {
        ...values,
        displaycategoryorder: parseInt(callbackres.response),
      };

      // We are storing icon json data to use in app and web with required key
      if (typeof data.image === "object" && data.image !== null) {
        data.image = JSON.stringify(data.image);
      }

      var eventguide = props.initialValues;

      // console.log("data :- ", data);

      return new Promise((resolve, reject) => {
        return props.insertEventguide(
          maxDisplayorderVal,
          props.session,
          data,
          eventguide,
          filechanged,
          eventguidefilesList,
          (result) => {
            if (result.error === 1) {
              props.stopSubmit("AddEventGuideForm");
              props.showError(COMMON_FAIL_MESSAGE);
              return reject(result.error);
            } else if (result.error === 2) {
              props.stopSubmit("AddEventGuideForm");
              props.showError(LocaleStrings.content_image_upload_error);
              return reject(result.error);
            } else {
              setTimeout(() => {
                props.stopSubmit("AddEventGuideForm");
                props.showSuccess(
                  LocaleStrings.eventguide_form_updated_success
                );

                // Call For Event Guide List On Modal Close (For Table refresh)
                this.close();
                props.finishOperationsCallback(!props.toEdit);

                return resolve(result);
              }, 300);
            }
            this.setState({ btnloading: false });
          }
        );
      });
    });
  }

  _handleInternalScreen = (e) => {
    let files = [
      { position: "file1", file: "", filename: "" },
      { position: "file2", file: "", filename: "" },
      { position: "file3", file: "", filename: "" },
      { position: "file4", file: "", filename: "" },
      { position: "file5", file: "", filename: "" },
      { position: "file6", file: "", filename: "" },
      { position: "file7", file: "", filename: "" },
      { position: "file8", file: "", filename: "" },
      { position: "file9", file: "", filename: "" },
      { position: "file10", file: "", filename: "" },
    ];

    let value = e.target.value;

    this.setState({ whatToshow: value });

    this.props.dispatch(change("AddEventGuideForm", "content", ""));
    this.props.dispatch(change("AddEventGuideForm", "weblink", ""));

    this.props.updateEventGuideFiles(files);
    // this.props.updateEventGuideFiles(eventguidefilesList);
    if (value) {
      if (value == "richtext") {
        this.setState({ isrichtext: true });
      } else {
        this.setState({ isrichtext: false });
      }
    }

    this.props.initialValues.type = value;
  };

  // Choose Or write Option Onchange
  _handleChooseOrText = (e) => {
    let value = e.target.value;

    if (value) {
      if (value == "choose") {
        this.setState({ isText: false });
      } else {
        this.setState({ isText: true });
      }
    }
  };

  onImageSave = (img) => {
    this.props.autofill("image", img == "" ? "" : img);
    this.setState({
      iconPreviewUrl: img == "" ? "removed" : img,
      ...(img === "" ? {} : { iconScreen: "iconFromImage" }),
    });
  };

  onImageChange = (imageAvailable) => {};

  onIconChange = (selectedIcon) => {
    this.props.autofill("image", selectedIcon);
    this.setState({ icon: selectedIcon, iconScreen: "iconFromLibrary" });
  };

  resetIcon = () => {
    this.props.autofill("image", "");
    this.setState({ icon: "removed", iconScreen: "" });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      submitting,
      invalid,
      filechanged,
      session,
      toEdit,
      initialValues,
      categoryList,
    } = this.props;
    let { isrichtext, whatToshow, iconScreen, iconPreviewUrl, icon } =
      this.state;
    let modalHeaderText = toEdit
      ? LocaleStrings.eventguide_title_text_edit
      : LocaleStrings.eventguide_title_text_add;
    let typeOptions = [
      { name: "Text", value: "richtext" },
      { name: "Docs", value: "pdf" },
      { name: "Page", value: "weblink" },
    ];

    var cateOptions = [];
    if (categoryList && Object.keys(categoryList).length > 0) {
      if (categoryList.data) {
        categoryList.data.map((value, index) => {
          var obj = {};

          obj["label"] = value.category;
          // obj["name"] = value.category;
          obj["value"] = value.category;
          cateOptions.push(obj);
        });
      }
    }

    // Edit;
    if (toEdit) {
      whatToshow = initialValues.type;
      if (whatToshow === "richtext") {
        if (!isrichtext) {
          isrichtext = true;
        }
      } else {
        if (isrichtext) {
          isrichtext = false;
        }
      }
    }

    let tempImage = "";
    let tempIcon = "";
    if (toEdit && initialValues.image) {
      let itsImage =
        initialValues.image.endsWith(".jpg") ||
        initialValues.image.endsWith(".png");
      if (itsImage) {
        tempImage = `${BASE_IMAGES_URL}/${initialValues.image}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
      } else {
        tempIcon = JSON.parse(initialValues.image);
      }
    }

    // For image
    if (iconPreviewUrl == "") {
      iconPreviewUrl = tempImage;
    } else if (iconPreviewUrl == "removed") {
      iconPreviewUrl = "";
    }

    // For icon
    if (icon == "") {
      icon = tempIcon;
    } else if (icon == "removed") {
      icon = "";
    }

    // var disabled = pristine || invalid || submitting;

    var disabled = false;
    if ((pristine || invalid || submitting) && !filechanged.ischanged) {
      disabled = true;
    } else if (filechanged.ischanged) {
      disabled = false;
    }

    // console.log(
    //   "pristine || invalid || submitting || filechanged.ischanged :- ",
    //   pristine,
    //   invalid,
    //   submitting,
    //   filechanged.ischanged
    // );
    // console.log("initialValues :- ", initialValues);
    // console.log("iconScreen :- ", iconScreen);
    // console.log("iconPreviewUrl :- ", iconPreviewUrl);
    // console.log("icon :- ", icon);

    return (
      <div>
        <Modal
          className="modal-container"
          show={this.props.modalData.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          enforceFocus={false}
          size={"lg"}
        >
          <form
            onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
            encType="multipart/form-data"
          >
            <Modal.Header>
              <div
                className="import-modal-title"
                style={{ paddingLeft: "15px" }}
              >
                {modalHeaderText}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.close()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-sm-9">
                  <div className="form-group">
                    <Field
                      name="category"
                      type="text"
                      label={LocaleStrings.eventguide_form_label_category}
                      placeholder={LocaleStrings.eventguide_form_ph_category}
                      component={this.renderCreateableSelect}
                      mandatory="true"
                      labelposition={LABEL_POSITION_TOP}
                      options={cateOptions}
                      list="category"
                      maxlength={MAXLENOBJ.category ? MAXLENOBJ.category : ""}
                      labelKey="label"
                      valueKey="value"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name="title"
                      label={LocaleStrings.eventguide_form_label_title}
                      placeholder={LocaleStrings.eventguide_form_ph_title}
                      type="text"
                      component={this.renderFieldText}
                      mandatory="true"
                      labelposition={LABEL_POSITION_TOP}
                      maxlength={MAXLENOBJ.title ? MAXLENOBJ.title : ""}
                    />
                  </div>

                  <div className="form-group">
                    <div>
                      <Field
                        name="type"
                        label={LocaleStrings.eventguide_form_label_type}
                        placeholder={LocaleStrings.eventguide_form_ph_type}
                        component={this.renderSelect}
                        mandatory="true"
                        labelposition={LABEL_POSITION_TOP}
                        opts={typeOptions}
                        onChange={this._handleInternalScreen}
                        value={this.props.initialValues.type}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    {whatToshow == "richtext" ? (
                      <Field
                        name="content"
                        label={LocaleStrings.eventguide_form_label_content}
                        placeholder={LocaleStrings.eventguide_form_php_content}
                        mandatory="true"
                        type="minimal"
                        component={this.renderRichTextareaWithLabelTinymce}
                        labelposition={LABEL_POSITION_TOP}
                        height={400}
                        maxlength={MAXLENOBJ.content ? MAXLENOBJ.content : ""}
                      />
                    ) : (
                      ""
                    )}
                    {whatToshow == "weblink" ? (
                      <Field
                        name="content"
                        label={LocaleStrings.eventguide_form_label_weblink}
                        placeholder={LocaleStrings.eventguide_form_ph_weblink}
                        type="text"
                        component={this.renderFieldText}
                        mandatory="true"
                        labelposition={LABEL_POSITION_TOP}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  {whatToshow == "pdf" ? (
                    <div className="form-group">
                      <EventGuideFileUpload />
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-sm-3">
                  <label className="control-label-top">
                    {LocaleStrings.eventguide_icon}
                    <span className="ps-1">
                      <BetaFeature />
                    </span>
                  </label>
                  <div className="eventguide-icon-bg p-2">
                    {iconScreen === "" ||
                    (iconScreen === "iconFromImage" &&
                      iconScreen != "iconFromLibrary") ? (
                      <IconCropper
                        displaySize={{ width: 150, height: 150 }} // For image display style
                        requiredSize={{ width: 84, height: 84 }} // For image size required validation
                        cropperSize={{ width: 100, height: 100 }} // Cropper display size. Note its add 50px for padding
                        border={10}
                        onImageSave={this.onImageSave}
                        onImageChange={this.onImageChange}
                        imagepath={iconPreviewUrl}
                        imageType="jpg"
                        className="drop-zone-area-custom-image"
                        insideImage="../../style/images/dummy-image-fill@3x.png"
                        insideImageStyle={{
                          width: 54,
                          height: 54,
                        }}
                        insideText="Drag and Drop to upload. Recommended icon size 84x84 px."
                      />
                    ) : (
                      ""
                    )}
                    {icon != "" ? (
                      <div
                        className="custom-align-center"
                        style={{ width: 150, height: 150 }}
                      >
                        <div className={`iconpicker-remove-button-position `}>
                          <Button
                            type="button"
                            className={`btn-custom-default-sm`}
                            onClick={this.resetIcon}
                          >
                            {LocaleStrings.button_remove}
                          </Button>
                        </div>
                        <i className={icon.title} style={{ fontSize: 120 }}></i>
                      </div>
                    ) : (
                      ""
                    )}
                    <Field
                      name="image"
                      type="text"
                      component={this.renderHiddenFieldText}
                    />
                    {(iconPreviewUrl === "") & (icon === "") ? (
                      <div className="mt-5">
                        <IconPicker value={icon} onChange={this.onIconChange} />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle=""
                className="btn btn-custom-white"
                onClick={this.close}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                bsStyle=""
                className="btn btn-custom-blue ml-10"
                loading={this.state.btnloading}
                type="submit"
                disabled={disabled}
              >
                {LocaleStrings.button_save_changes}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function validate(values, props) {
  var errors = {};

  var requiredFields = ["title", "type", "content"];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = LocaleStrings.required;
    }
  });

  if (values.type == "weblink")
    if (values.content) {
      if (!validateUrl(values.content)) {
        errors.content = LocaleStrings.invalid_url;
      }
    }

  if (!values.category) {
    errors["category"] = LocaleStrings.required;
  } else {
  }

  if (values.category) {
    let res = "";
    let cate = values.category;
    // console.log(typeof cate);
    if (typeof cate !== "object" && cate !== "") {
      res = cate;
    } else {
      res = cate.value;
    }

    if (res && MAXLENOBJ && res.length > MAXLENOBJ.category) {
      errors["category"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.category;
    }
  }

  if (values["title"] && MAXLENOBJ) {
    if (values["title"].length > MAXLENOBJ.title) {
      errors["title"] = LocaleStrings.max_characters_left + MAXLENOBJ.title;
    }
  }

  if (values["content"] && MAXLENOBJ) {
    if (
      values["content"].replace(/<[^>]+>/g, "").replace("&nbsp;", "").length >
      MAXLENOBJ.content
    ) {
      errors["content"] = LocaleStrings.max_characters_left + MAXLENOBJ.content;
    }
  }

  return errors;
}

function mapStateToProps(state) {
  var toEdit = false;
  if (state.eventguide && state.eventguide.id) {
    toEdit = true;
  }

  return {
    session: state.session,
    modalData: state.eventguideModel,
    toEdit,
    initialValues: state.eventguide,
    maxDisplayorder: state.maxDisplayordereventguide,
    filechanged: state.eventguidefilesChanged,
    eventguidefilesList: state.eventguidefilesList,
    eventGuideList: state.eventGuideList,
    categoryList: state.categoryList,
    formValues: getFormValues("UploadProductForm")(state),
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openEventGuideModal,
  filesChanged,
  insertEventguide,
  fetchEventGuideList,
  loadEditeventguidesData,
  updateEventGuideFiles,
  getDispalyCategoryOrder,
})(
  reduxForm({
    validate,
    form: "AddEventGuideForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditEventGuide)
);
